import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { updateReportStatusAction } from '../../redux/actions/orderActions';
import { Link } from 'react-router-dom';
import { createPortal } from 'react-dom';



const SingleOrderButtons = ({ order, user }) => {


    const dispatch = useDispatch();



    const { loading, error, message } = useSelector(state => state.createReport)


    const [viewReport, setViewReport] = useState(false)
    const [showPopup, setShowPopup] = useState(false);
    const [actionToPerform, setActionToPerform] = useState('');
    const [popupHeading, setpopupHeading] = useState('');
    const [popupPara, setpopupPara] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [coords, setCoords] = useState({ top: 0, left: 0 });




    const handleShowPopup = (status) => {


        setShowPopup(true);
        setActionToPerform(status);


        if (status === "UNDER_REVIEW") {
            setpopupHeading("Mark as Under Review");
            setpopupPara("Are you sure you want to mark this Report as under review?");
        }
        if (status === "RESOLVED") {
            setpopupHeading("Mark as Resolved");
            setpopupPara("Are you sure you want to mark this Report as resolved?");
        }
        if (status === "REJECTED") {
            setpopupHeading("Mark as Rejected");
            setpopupPara(`Are you sure you want to mark this Report as rejected?`);
        }
        if (status === "URGENT") {
            setpopupHeading("Mark as Urgent");
            setpopupPara(`Are you sure you want to mark this Report Urgent?`);
        }
        if (status === "CANCELLED") {
            setpopupHeading("Cancel Report");
            setpopupPara(`Are you sure you want to cancel this Report?`);
        }
    }













    const handleDispatch = () => {


        if (!actionToPerform) return toast.error("Please select an action to Perform");


        dispatch(updateReportStatusAction(
            {
                report_id: order?.id,
                order_id: order?.order_id,
                status: actionToPerform
            }))



    }





    useEffect(() => {
        if (message) {
            setShowPopup(false);
            setActionToPerform('');
        }
        if (error) {
            setShowPopup(false);
            setActionToPerform('');
        }
    }, [message, error])







    const handleToggle = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setCoords({
            top: rect.bottom + window.scrollY,
            left: rect.right + window.scrollX - 192 // w-48 is 12rem = 192px
        });
        setIsOpen(!isOpen);
    };

    return (
        <Fragment>
            <div className="flex items-center gap-2 justify-center">
                <button
                    className="px-3 py-1.5 flex-center bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 border border-blue-200 transition-all text-sm font-semibold"
                    onClick={() => setViewReport(true)}
                >
                    View
                </button>

                <div className="relative">
                    <button
                        className="px-3 py-1.5 flex-center bg-gray-50 text-gray-700 rounded-lg hover:bg-gray-100 border border-gray-200 transition-all text-sm font-semibold flex items-center gap-1"
                        onClick={handleToggle}
                    >
                        Actions <i className={`fa-solid fa-chevron-down text-xs transition-transform ${isOpen ? 'rotate-180' : ''}`}></i>
                    </button>

                    {isOpen && document.body && createPortal(
                        <div style={{ position: 'absolute', top: coords.top, left: coords.left }} className="w-48 bg-white rounded-lg shadow-lg border border-gray-100 z-[999999] py-1">
                            {(user?.id === order?.against_user_id || user?.role === "ADMIN" || user?.role === "SUPER_ADMIN") && (
                                <>
                                    {(order?.status === "PENDING" || order?.status === "URGENT") && (
                                        <button
                                            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                            onClick={() => { handleShowPopup("UNDER_REVIEW"); setIsOpen(false); }}
                                        >
                                            <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
                                            Under Review
                                        </button>
                                    )}
                                    {(order?.status === "PENDING" || order?.status === "UNDER_REVIEW" || order?.status === "URGENT") && (
                                        <button
                                            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                            onClick={() => { handleShowPopup("RESOLVED"); setIsOpen(false); }}
                                        >
                                            <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                                            Resolved
                                        </button>
                                    )}
                                </>
                            )}
                            {user?.role !== "PM" && user?.role !== "PMM" && (
                                <>
                                    {(order?.status === "PENDING" || order?.status === "UNDER_REVIEW") && (
                                        <button
                                            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                            onClick={() => { handleShowPopup("URGENT"); setIsOpen(false); }}
                                        >
                                            <span className="w-2 h-2 bg-purple-500 rounded-full"></span>
                                            Mark as Urgent
                                        </button>
                                    )}
                                    {(order?.status === "PENDING" || order?.status === "UNDER_REVIEW" || order?.status === "URGENT") && (
                                        <button
                                            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                            onClick={() => { handleShowPopup("REJECTED"); setIsOpen(false); }}
                                        >
                                            <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                                            Rejected
                                        </button>
                                    )}
                                    <Link
                                        to={`/messenger?new_chat=true&user_id=${order?.against_user_id}`}
                                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                        onClick={() => setIsOpen(false)}
                                    >
                                        <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
                                        Start Chat
                                    </Link>
                                </>
                            )}
                            {user?.id === order?.reported_by && (order?.status === "PENDING" || order?.status === "UNDER_REVIEW" || order?.status === "URGENT") && (
                                <button
                                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                    onClick={() => { handleShowPopup("CANCELLED"); setIsOpen(false); }}
                                >
                                    <span className="w-2 h-2 bg-gray-500 rounded-full"></span>
                                    Cancel
                                </button>
                            )}
                        </div>,
                        document.body
                    )}
                </div>
            </div>
            {viewReport && (
                <div className="fixed inset-0 flex-center bg-zinc-900/50 backdrop-blur-sm z-[99999999999999] p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden border border-zinc-100 transform transition-all">

                        {/* Header */}
                        <div className="px-6 py-5 flex justify-between items-center border-b border-gray-100">
                            <div className="flex gap-3 items-center">
                                <div className="w-10 h-10 bg-indigo-50 rounded-xl flex-center text-indigo-600 text-xl">
                                    <i className="fa-regular fa-file-lines"></i>
                                </div>
                                <div>
                                    <h3 className="font-bold text-lg text-zinc-800 font-jakarta">Report Details</h3>
                                    <p className="text-xs text-zinc-500">View submitted report information</p>
                                </div>
                            </div>

                            <button
                                className="w-8 h-8 flex-center rounded-full bg-zinc-100 text-zinc-500 hover:bg-zinc-200 hover:text-zinc-800 transition-colors"
                                onClick={() => setViewReport(false)}
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>

                        {/* Content */}
                        <div className="p-6 space-y-5">

                            {/* Details Grid */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div className="bg-zinc-50 p-4 rounded-xl border border-zinc-200">
                                    <span className="text-xs font-bold text-zinc-500 uppercase tracking-wider">Order ID</span>
                                    <p className="text-base font-bold text-zinc-800 mt-1">{String(order?.order_id).padStart(6, '0')}</p>
                                </div>
                                <div className="bg-zinc-50 p-4 rounded-xl border border-zinc-200">
                                    <span className="text-xs font-bold text-zinc-500 uppercase tracking-wider">Report Type</span>
                                    <p className="text-base font-bold text-zinc-800 mt-1">{order?.report_type}</p>
                                </div>
                            </div>

                            {/* Status */}
                            <div className="bg-zinc-50 p-4 rounded-xl border border-zinc-200">
                                <span className="text-xs font-bold text-zinc-500 uppercase tracking-wider">Current Status</span>
                                <div className="mt-1">
                                    <span className={`inline-block px-3 py-1 text-xs font-bold rounded-full 
                                        ${order?.status === "PENDING" && "bg-amber-100 text-amber-700"}
                                        ${order?.status === "UNDER_REVIEW" && "bg-blue-100 text-blue-700"}
                                        ${order?.status === "RESOLVED" && "bg-green-100 text-green-700"}
                                        ${order?.status === "REJECTED" && "bg-red-100 text-red-700"}
                                        ${order?.status === "URGENT" && "bg-purple-100 text-purple-700"}
                                        ${order?.status === "CANCELLED" && "bg-gray-100 text-gray-700"}
                                    `}>
                                        {order?.status}
                                    </span>
                                </div>
                            </div>

                            {/* Reason */}
                            <div className="bg-zinc-50 p-4 rounded-xl border border-zinc-200">
                                <span className="text-xs font-bold text-zinc-500 uppercase tracking-wider">Report Reason</span>
                                <p className="text-sm text-zinc-700 mt-2 leading-relaxed whitespace-pre-line">
                                    {order?.report_reason}
                                </p>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="px-6 py-4 bg-zinc-50/50 border-t border-gray-100 flex justify-end">
                            <button
                                className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white font-semibold py-2.5 px-6 rounded-xl hover:shadow-lg hover:shadow-indigo-100 transition-all active:scale-[0.98]"
                                onClick={() => setViewReport(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showPopup && (
                <div className="fixed inset-0 flex-center bg-zinc-900/50 backdrop-blur-sm z-[99999999999]">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-zinc-100 transform transition-all p-6">

                        {/* Icon */}
                        <div className="mx-auto w-12 h-12 bg-amber-50 rounded-full flex-center text-amber-600 text-2xl mb-4">
                            <i className="fa-solid fa-circle-question"></i>
                        </div>

                        {/* Content */}
                        <div className="text-center">
                            <h3 className="font-bold text-lg text-zinc-800 font-jakarta mb-2">
                                {popupHeading}
                            </h3>
                            <p className="text-sm text-zinc-500 leading-relaxed whitespace-pre-line">
                                {popupPara}
                            </p>
                        </div>

                        {/* Buttons */}
                        <div className="flex gap-3 mt-6">
                            {actionToPerform !== "HidePopup" && (
                                <button
                                    className="flex-1 text-zinc-600 font-semibold py-2.5 px-4 rounded-xl border border-zinc-200 hover:bg-zinc-50 transition-all active:scale-[0.98]"
                                    onClick={() => {
                                        setShowPopup(false)
                                        setActionToPerform("")
                                    }}
                                >
                                    No
                                </button>
                            )}

                            <button
                                className={`flex-1 font-semibold py-2.5 px-4 rounded-xl text-white transition-all active:scale-[0.98]
                                    ${actionToPerform === "REJECTED" || actionToPerform === "CANCELLED"
                                        ? "bg-gradient-to-r from-red-600 to-red-700 hover:shadow-lg hover:shadow-red-100"
                                        : "bg-gradient-to-r from-indigo-600 to-indigo-700 hover:shadow-lg hover:shadow-indigo-100"
                                    }`}
                                onClick={handleDispatch}
                                disabled={loading}
                            >
                                {loading ? "Processing..." : "Yes, Proceed"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
}

export default SingleOrderButtons